module.exports = __webpack_public_path__ + "static/media/blue35.b32d03b5.png";